import React, { useState } from 'react';
import { useDocumentState } from '../../../../../../contexts/DocumentContext';
import { useModals } from '../../../../../../contexts/ModalsContext';
import UnlockDocumentModal from './unlockDocumentModal';
import UnlockDocumentButton from './unlockDocumentButton';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as LockIcon } from '../../../icons/lock-icon.svg';
import styles from './styles.module.scss';

interface Props {
  teamId: string;
  documentId: string;
}

const UnlockDocumentContainer = ({ documentId, teamId }: Props) => {
  const { showGrantAccessModal: isGrantAccessModalOpen } = useModals();
  const [showModal, setShowModal] = useState(isGrantAccessModalOpen);
  const { state } = useDocumentState();

  return (
    <>
      <div className={styles['locked-label']}>
        <LockIcon height="28" className="mr-2" />
        <FormattedMessage
          id="document-wizard-header.action.Locked-document"
          defaultMessage="Locked"
          data-testid="document-wizard-header-Locked-documen"
        />
      </div>
      <UnlockDocumentButton onClick={() => setShowModal(true)} />
      <UnlockDocumentModal
        show={showModal}
        onHide={() => setShowModal(false)}
        teamId={teamId}
        documentId={documentId}
      />
    </>
  );
};

export default UnlockDocumentContainer;
